import React from 'react'

interface FilterCheckboxGroupProps {
 label: string
 options: Array<{ value: string; label: string }>
 selected: string[]
 onChange: (selected: string[]) => void
}

export const FilterCheckboxGroup: React.FC<FilterCheckboxGroupProps> = ({
 label,
 options,
 selected,
 onChange
}) => {
 const toggleOption = (value: string) => {
 if (selected.includes(value)) {
 onChange(selected.filter((v) => v !== value))
 } else {
 onChange([...selected, value])
 }
 }

 return (
 <div className="space-y-3">
 <label className="block text-sm font-medium text-foreground">
 {label}
 </label>
 <div className="flex flex-wrap gap-2">
 {options.map((option) => (
 <button
 key={option.value}
 type="button"
 onClick={() => toggleOption(option.value)}
 className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
 selected.includes(option.value)
 ? 'bg-accent text-white hover:bg-accent/90'
 : 'bg-surface text-foreground hover:bg-gray-200'
 }`}
 >
 {option.label}
 </button>
 ))}
 </div>
 </div>
 )
}

